import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { WidgetNodeComponent } from './widget.component';
import { DEFAULT_WIDGET_PROPS } from './widget.model';

export const WIDGET_NODE_NAME = 'widget';

const widgetClassName = 'widget';

export const WidgetExtension = (injector: Injector) => {
  return Node.create({
    name: WIDGET_NODE_NAME,
    group: 'block',
    atom: true,
    selectable: true,
    // draggable: true, // Removed to prevent dragging from anywhere in the component

    addAttributes() {
      return {
        widget_type: {
          default: DEFAULT_WIDGET_PROPS.widget_type,
          renderHTML: (attributes) => {
            return { 'data-widget-type': attributes['widget_type'] };
          },
          parseHTML: (element) => {
            return element.getAttribute('data-widget-type');
          },
        },
        title: {
          default: null,
        },
        config: {
          default: DEFAULT_WIDGET_PROPS.config,
          // Serialize config as JSON string for HTML (copy/paste)
          renderHTML: (attributes) => {
            const config = attributes['config'];
            if (!config) {
              return {};
            }
            return {
              'data-config': JSON.stringify(config),
            };
          },
          // Parse config from JSON string when pasting
          parseHTML: (element) => {
            const configStr = element.getAttribute('data-config');
            if (!configStr) {
              return DEFAULT_WIDGET_PROPS.config;
            }
            try {
              return JSON.parse(configStr);
            } catch {
              return DEFAULT_WIDGET_PROPS.config;
            }
          },
        },
        height: {
          default: null,
          renderHTML: (attributes) => {
            return attributes['height'] ? { 'data-height': attributes['height'] } : {};
          },
          parseHTML: (element) => {
            const val = element.getAttribute('data-height');
            return val ? parseInt(val, 10) : null;
          },
        },
        width: {
          default: null,
          renderHTML: (attributes) => {
            return attributes['width'] ? { 'data-width': attributes['width'] } : {};
          },
          parseHTML: (element) => {
            const val = element.getAttribute('data-width');
            return val ? parseInt(val, 10) : null;
          },
        },
        resizable: {
          default: true,
          renderHTML: (attributes) => {
            return attributes['resizable'] === false ? { 'data-resizable': 'false' } : {};
          },
          parseHTML: (element) => {
            return element.getAttribute('data-resizable') === 'false' ? false : true;
          },
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== widgetClassName);
            return { class: `${widgetClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [
        {
          tag: `div.${widgetClassName}`,
        },
      ];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: widgetClassName }, HTMLAttributes)];
    },

    addNodeView() {
      return AngularNodeViewRenderer(WidgetNodeComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
